import type { QueryFilter } from '@domain/schemas/filters.schema';
import { v4 as uuidv4 } from 'uuid';

import type { FilterRow } from '../types';

export const toFilterRows = (filters: QueryFilter[]): FilterRow[] =>
  filters.map((filter) => ({ ...filter, id: uuidv4() }));

const normalize = (f: QueryFilter) => JSON.stringify([f.field, f.comparator, [...new Set(f.values)].sort()]);

export const areFiltersEqual = (a: QueryFilter[], b: QueryFilter[]): boolean => {
  if (a.length !== b.length) return false;
  const sa = a.map(normalize).sort();
  const sb = b.map(normalize).sort();
  return sa.every((value, i) => value === sb[i]);
};
